import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Dimmer } from "../../spinner";
import { Mensaje } from "../../mensajes2";
import useTable from "../../useTable";
import { formatMoneda } from "../../../util/varios";
import { ModalAgregarDeudaComercio } from "./modalAgregarDeudaComercio";
import { ModalAgregarDeudaInmueble } from "./modalAgregarDeudaInmueble";
import TablaHistoricosInmuebles from "../inmueblesUrbanos/tablaHistoricoInmuebe";
import TablaPagosComercio from "../actividadEconomica/tablaPagosComercios";
import TablaPagosVehiculos from "../impuestovehiculos/tablaPagosVehiculos";
import TablaHistoricosEjidos from "../rentaInmobiliaria/tabaHistoricoEjidos";
import TablaHistoricosApuestas from "../juegoApuestas/tablaHistoricoApuestas";
import moment from "moment";

export const ModalGestionDeuda = (props) => {
    let op = require('../../../../src/modulos/datos');
    const token = JSON.parse(sessionStorage.getItem("jwtToken"));
    const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
    const [impuesto, setImpuesto] = useState(0.00);
    const [interes, setInteres] = useState(0.00);
    const [recargo, setRecargo] = useState(0.00);
    const [multa, setMulta] = useState(0.00);
    const [totDeuda, setTotDeuda] = useState();
    const espiritu = JSON.parse(localStorage.getItem("espiritu"));
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);
    const [deuda, setDeuda] = useState([]);
    const [historico, setHistorico] = useState([]);
    const [deudaSel, setDeudaSel] = useState();
    const [itemSelect, setItemSelect] = useState(-1);
    const [activo, setActivo] = useState(true);
    const [config, setConfig] = useState();
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [contribuyente, setContribuyente] = useState({
        idcontribuyente: "",
        nombre: "",
        ritm: "",
        rif: "",
        direccion: "",
    });
    const [filterFn, setFilterFn] = useState({
        fn: (items) => {
            return items;
        },
    });
    const [selected, setSelected] = useState([]);

    const headCells = [
        {
            id: "1",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "AÑO",
            textAlign: "center",
            disableSorting: true,
        },
        {
            id: "2",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "MES",
            textAlign: "center",
            disableSorting: true,
        },
        {
            id: "4",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "MONTO",
            textAlign: "center",
            disableSorting: true,
        },
        {
            id: "5",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "INTERES MORA",
            textAlign: "center",
            disableSorting: true,
        },
        {
            id: "6",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "RECARGOS",
            textAlign: "center",
            disableSorting: true,
        },
    ];

    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(deuda, headCells, filterFn);

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            setSelected(deuda);
            return;
        } else {
            setSelected([]);
        }
    };

    const seleccionarFila = (index, item) => (event) => {

        setItemSelect(index);
        setActivo(false);

        setDeudaSel(item);
    };

    const blanquear = () => {
        setOperacion(0);
        setDeuda([]);
        setDeudaSel();
        setContribuyente({
            idcontribuyente: "",
            nombre: "",
            ritm: "",
            rif: "",
            direccion: "",
        });
    };

    const SelectDeuda = () => {
        setActivate(true);
        let tab = "";
        let tipod = "";
        let endpoint = '';
        switch (props.tipo) {
            case "comercio":
                endpoint = `${op.conexion}/api/industria/deudacomercio?idcomercio=${props.contribuyente.idcontribuyente}&fecha=${fechaSistema}&espiritu=${espiritu}&tipounid=${1}`;
                break;
            case "inmueble":
                endpoint = `${op.conexion}/api/inmueble/deudainmueble?idinmueble=${props.contribuyente.idcontribuyente}&fecha=${fechaSistema}&espiritu=${espiritu}`;
                break;
            case "vehiculo":
                endpoint = `${op.conexion}/api/vehiculo/deudavehiculo?idvehiculo=${props.contribuyente.idcontribuyente}&fecha=${fechaSistema}&espiritu=${espiritu}`;
                break;
            case "rentas":
                if (espiritu === 0) {
                    endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${props.contribuyente.idcontribuyente}&fecha=${fechaSistema}&tabla=${props.tabla} `;
                } else {
                    //endpoint = `${op.conexion}/api/aseo/deudarenta1?idrentas=${props.contribuyente.idcontribuyente}&fecha=${fechaSistema}&tabla=${props.tabla} `;
                    endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${props.contribuyente.idcontribuyente}&fecha=${fechaSistema}&tabla=${props.tabla} `;
                }
                break;
            case "5":

                break;

            default:
                break;
        }


        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    app: "admin"
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    let deu = [];
                    let his = [];
                    let totdeu = parseFloat(0.0);
                    let totrec = parseFloat(0.0);
                    let totinte = parseFloat(0.0);
                    let totimpu = parseFloat(0.0);
                    let totmulta = parseFloat(0.0);
                    var mesactu = (new Date(fechaSistema).getMonth() + 1).toString().padStart(2, 0);
                    var anioactu = JSON.parse(localStorage.getItem("anioactu"));
                    for (let i = 0; i < response.data.length; i++) {
                        if (response.data[i].fechapago === null) {
                            if (props.tipo === "rentas") {
                                if (parseInt(response.data[i].anio) < parseInt(anioactu)) {
                                    totimpu = totimpu + Math.round(parseFloat(response.data[i].mondeu) * Math.pow(10, 2)) / Math.pow(10, 2);
                                    totrec = totrec + Math.round(parseFloat(response.data[i].recargodeu) * Math.pow(10, 2)) / Math.pow(10, 2);
                                    totinte = totinte + Math.round(parseFloat(response.data[i].intmoradeu) * Math.pow(10, 2)) / Math.pow(10, 2);
                                    totinte = totinte + Math.round(parseFloat(response.data[i].intmoradeu) * Math.pow(10, 2)) / Math.pow(10, 2);
                                    totmulta = totmulta + Math.round(parseFloat(response.data[i].multa) * Math.pow(10, 2)) / Math.pow(10, 2);
                                    deu.push({
                                        anio: response.data[i].anio,
                                        mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                        monto: response.data[i].mondeu,
                                        intereses: response.data[i].intmoradeu,
                                        recargo: response.data[i].recargodeu,
                                        multa: response.data[i].multa,
                                        retenciones: response.data[i].retencion,
                                        credito: response.data[i].acreditacion,
                                        totalperi: response.data[i].subtotal,
                                        status: response.data[i].estatus,
                                        idfac: response.data[i].idfact,
                                        nummes: response.data[i].nmes,
                                        estatusfac: response.data[i].estatusfac,
                                        tipotransaccion: response.data[i].tipotransaccion,
                                        tipodeuda: response.data[i].tipodeuda,
                                        nombredeuda: espiritu === 0 ? response.data[i].nombredeuda : 'deudacomercio',
                                        idrent: espiritu === 0 ? response.data[i].idrent : 0
                                    });
                                } else if (parseInt(response.data[i].anio) === parseInt(anioactu) && parseInt(response.data[i].nmes) < parseInt(mesactu)) {
                                    totimpu = totimpu + Math.round(parseFloat(response.data[i].mondeu) * Math.pow(10, 2)) / Math.pow(10, 2);
                                    totrec = totrec + Math.round(parseFloat(response.data[i].recargodeu) * Math.pow(10, 2)) / Math.pow(10, 2);
                                    totinte = totinte + Math.round(parseFloat(response.data[i].intmoradeu) * Math.pow(10, 2)) / Math.pow(10, 2);
                                    totinte = totinte + Math.round(parseFloat(response.data[i].intmoradeu) * Math.pow(10, 2)) / Math.pow(10, 2);
                                    totmulta = totmulta + Math.round(parseFloat(response.data[i].multa) * Math.pow(10, 2)) / Math.pow(10, 2);
                                    deu.push({
                                        anio: response.data[i].anio,
                                        mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                        monto: response.data[i].mondeu,
                                        intereses: response.data[i].intmoradeu,
                                        recargo: response.data[i].recargodeu,
                                        multa: response.data[i].multa,
                                        retenciones: response.data[i].retencion,
                                        credito: response.data[i].acreditacion,
                                        totalperi: response.data[i].subtotal,
                                        status: response.data[i].estatus,
                                        idfac: response.data[i].idfact,
                                        nummes: response.data[i].nmes,
                                        estatusfac: response.data[i].estatusfac,
                                        tipotransaccion: response.data[i].tipotransaccion,
                                        tipodeuda: response.data[i].tipodeuda,
                                        nombredeuda: espiritu === 0 ? response.data[i].nombredeuda : 'deudacomercio',
                                        idrent: espiritu === 0 ? response.data[i].idrent : 0
                                    });
                                }
                            } else if (props.tipo === "comercio") {
                                totimpu = totimpu + Math.round(parseFloat(response.data[i].mondeu) * Math.pow(10, 2)) / Math.pow(10, 2);
                                totrec = totrec + Math.round(parseFloat(response.data[i].recargodeu) * Math.pow(10, 2)) / Math.pow(10, 2);
                                totinte = totinte + Math.round(parseFloat(response.data[i].intmoradeu) * Math.pow(10, 2)) / Math.pow(10, 2);
                                totinte = totinte + Math.round(parseFloat(response.data[i].intmoradeu) * Math.pow(10, 2)) / Math.pow(10, 2);
                                totmulta = totmulta + Math.round(parseFloat(response.data[i].multa) * Math.pow(10, 2)) / Math.pow(10, 2);
                                deu.push({
                                    anio: response.data[i].anio,
                                    mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                    monto: response.data[i].mondeu,
                                    intereses: response.data[i].intmoradeu,
                                    recargo: response.data[i].recargodeu,
                                    multa: response.data[i].multa,
                                    retenciones: response.data[i].retencion,
                                    credito: response.data[i].acreditacion,
                                    totalperi: response.data[i].subtotal,
                                    status: response.data[i].estatus,
                                    idfac: response.data[i].idfact,
                                    nummes: response.data[i].nmes,
                                    estatusfac: response.data[i].estatusfac,
                                    tipotransaccion: response.data[i].tipotransaccion,
                                    tipodeuda: response.data[i].tipodeuda,
                                    nombredeuda: espiritu === 0 ? response.data[i].nombredeuda : 'deudacomercio',
                                    idrent: espiritu === 0 ? response.data[i].idrent : 0
                                });
                            } else {
                                //totimpu = totimpu + Math.round(parseFloat(response.data[i].mondeu) * parseFloat(props.factorcambio) * Math.pow(10, 2)) / Math.pow(10, 2);
                                totimpu = totimpu + (parseFloat(response.data[i].mondeu) * parseFloat(props.factorcambio));
                                //totrec = totrec + Math.round(parseFloat(response.data[i].recargodeu) * parseFloat(props.factorcambio) * Math.pow(10, 2)) / Math.pow(10, 2);
                                totrec = totrec + (parseFloat(response.data[i].recargodeu) * parseFloat(props.factorcambio));
                                //totinte = totinte + Math.round(parseFloat(response.data[i].intmoradeu) * parseFloat(props.factorcambio) * Math.pow(10, 2)) / Math.pow(10, 2);
                                totinte = totinte + (parseFloat(response.data[i].intmoradeu) * parseFloat(props.factorcambio));
                                //totmulta = totmulta + Math.round(parseFloat(response.data[i].multa) * parseFloat(props.factorcambio) * Math.pow(10, 2)) / Math.pow(10, 2);
                                totmulta = totmulta + (parseFloat(response.data[i].multa) * parseFloat(props.factorcambio));
                                deu.push({
                                    anio: response.data[i].anio,
                                    mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                    monto: response.data[i].mondeu * props.factorcambio,
                                    intereses: response.data[i].intmoradeu * props.factorcambio,
                                    recargo: response.data[i].recargodeu * props.factorcambio,
                                    multa: response.data[i].multa * props.factorcambio,
                                    retenciones: response.data[i].retencion,
                                    credito: response.data[i].acreditacion,
                                    totalperi: response.data[i].subtotal,
                                    status: response.data[i].estatus,
                                    idfac: response.data[i].idfact,
                                    nummes: response.data[i].nmes,
                                    estatusfac: response.data[i].estatusfac,
                                    tipotransaccion: response.data[i].tipotransaccion,
                                    tipodeuda: response.data[i].tipodeuda,
                                    nombredeuda: espiritu === 0 ? response.data[i].nombredeuda : 'deudacomercio',
                                    idrent: espiritu === 0 ? response.data[i].idrent : 0
                                });
                            }

                        } else {
                            his.push({
                                anio: response.data[i].anio,
                                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                monto: response.data[i].mondeu,
                                intereses: response.data[i].intmoradeu,
                                recargo: response.data[i].recargodeu,
                                multa: response.data[i].multa,
                                descuento: response.data[i].mondescue,
                                recibo: response.data[i].numreci,
                                fechapago: response.data[i].fechapago,
                                status: response.data[i].estatus,
                                idfac: response.data[i].idfact,
                                estatusfac: response.data[i].estatusfac,
                                tipotransaccion: response.data[i].tipotransaccion,
                            });
                        }
                    }
                    setImpuesto(totimpu);
                    setRecargo(totrec);
                    setInteres(totinte);
                    //setMulta(totmulta);
                    //let total = totimpu+totrec+totinte; 
                    setTotDeuda(totimpu + totrec + totinte)
                    setDeuda(deu);
                    setHistorico(his);
                    //setSelected([]);
                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
                setActivate(false);
            })
            .finally(() => setActivate(false));
    };

    const cancelar = () => {
        blanquear();
        props.onHide();
    };

    useEffect(() => {
        seleccionarConfiguracion();
    }, []);

    const gestionar = (n) => {

        setOperacion(n);
        if (deudaSel === null) {
            setDeudaSel(deuda[0]);
        }
        if (props.tipo === 'comercio') {
            setShow(true)
        } else if (props.tipo === 'inmueble' || props.tipo === 'rentas' || props.tipo === 'vehiculo') {
            setShow2(true)
        }
    };

    const seleccionarConfiguracion = () => {
        let campos = "*";
        let nomtab = "";
        let orden = "1";
        switch (props.tipo) {
            case "comercio":
                nomtab = "configindustria";
                break;
            case "inmueble":
                nomtab = "configinmueble";
                break;
            case "vehiculo":
                nomtab = "configvehiculo";
                break;
            case "rentas":
                nomtab = "configrentas";
                break;
            case "apuestas":
                nomtab = "configapuesta";
                break;
        }
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
        setActivate(true);
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    setConfig(response.data[0]);
                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error.response.data.message,
                    icono: "error",
                });
                setActivate(false);
            });
    };

    const imprimirDeuda = (event) => {
        event.preventDefault();
        let fechasistema = JSON.parse(localStorage.getItem('fechasistema'));
        let espiritu = JSON.parse(localStorage.getItem('espiritu'));
        var reporte = '';
        var id = contribuyente.idcontribuyente;
        var valpetro = props.factorCambio;
        if (props.tipo === "comercio"){
            reporte = 'EdoCtaCorto2Com';
            window.open(op.reportes + "/actividadeconomica?" + "reporte=" + reporte + "&id=" + id + "&fecha=" + moment.utc(fechasistema).format('YYYY/MM/DD') + "&espiritu=" + espiritu, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
        } else if (props.tipo === "inmueble"){
            reporte = "EdoCtaCorto2Inm";
            window.open(op.reportes + "/inmueblesurbanos?" + "reporte=" + reporte + "&id=" + id, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
        } else if (props.tipo === "vehiculo"){
            var idv = "VEH.IdVehiculo=" + id;
            var crit = null;
            var radioBolivares = 1;
            var sql1 = crit;
            reporte = 'EdoCtaCorto2Vehic';
            window.open(op.reportes + "/impuestovehiculo?" + "reporte=" + "&sql1=" + sql1 + "&sql=" + idv + "&valpetro=" + valpetro + "&radioBolivares=" + radioBolivares , "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
        } else if (props.tipo === "rentas"){
            reporte = "EdoCtaCorto2RentaInmob";
            var parametro = "1";
            window.open(op.reportes + "/rentasinmobiliarias?" + "reporte=" + reporte + "&id=" + id + "&valor=" + valpetro + "&tipo=" + parametro, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
        }
        
    }

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                SelectDeuda();
                setContribuyente(props.contribuyente);
            }}
        >
            <Modal.Header className="col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant rounded-top text-light">
                <h3>Gestionar de Deuda</h3>
                <a type='button'
                    className="fw-bold text-light fs-6"
                    onClick={cancelar}
                >
                    Salir <i className="fa fa-times ms-2"></i>
                </a>
            </Modal.Header>
            <Modal.Body>
                <div className="container-fluid rounded">
                    <div className="tab-content" id="ex-with-icons-content">
                        <div
                            className="tab-pane fade show active"
                            id="tab-1"
                            role="tabpanel"
                            aria-labelledby="ex-with-icons-tab-1"
                        >
                            <fieldset className="row border-azul rounded mx-auto col-sm-12">
                                <legend className="float-none m-0 w-auto">
                                    Datos Generales
                                </legend>

                                <div class="input-group input-group-sm mb-1 px-0 col-md-2">
                                    <span class="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Código:</span>
                                    <input type="text" value={contribuyente ? contribuyente.idcontribuyente : ""} disabled class="form-control bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>

                                {props.tipo === "comercio" ?

                                    <div class="input-group input-group-sm mb-1 px-0 col-md-2">
                                        <span class="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">N° de Ritm:</span>
                                        <input type="text" value={contribuyente ? contribuyente.ritm : ""} disabled class="form-control bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                    </div>

                                    : props.tipo === "inmueble" ?

                                        <div className="input-group input-group-sm col-md-2">
                                            <label className="form-label fw-bold">N° Ficha Catastral:</label>{" "}
                                            &nbsp; {contribuyente ? contribuyente.ritm : ""}
                                        </div>
                                        : props.tipo === "vehiculo" ?

                                            <div className="input-group input-group-sm col-md-2">
                                                <label className="form-label fw-bold">N° Placa:</label>{" "}
                                                &nbsp; {contribuyente ? contribuyente.ritm : ""}
                                            </div>

                                            : props.tipo === "rentas" ?
                                                <div className="col-md-7">
                                                    <div className="input-group input-group-sm">
                                                        <label className="form-label fw-bold">Tipo de Rentas:</label>{" "}
                                                        &nbsp; {contribuyente ? contribuyente.ritm : ""}
                                                    </div>
                                                </div>
                                                : ""}
                                <div className="col">

                                </div>

                                <div class="input-group input-group-sm mb-1 px-0 col-md-9">
                                    <span class="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Nombre:</span>
                                    <input type="text" value={contribuyente ? contribuyente.nombre : ""} disabled class="form-control bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>
                                <div class="input-group input-group-sm mb-1 px-0 col-md-3">
                                    <span class="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Cédula / Rif:</span>
                                    <input type="text" value={contribuyente ? contribuyente.rif : ""} disabled class="form-control bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>
                                <div class="input-group input-group-sm mb-1 px-0 col-md-12">
                                    <span class="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Dirección:</span>
                                    <input type="text" value={contribuyente ? contribuyente.direccion : ""} disabled class="form-control bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>

                            </fieldset>
                            <ul className="nav mb-2" id="ex-with-icons" role="tablist">
                            <li className="nav-item" role="presentation">
                                    <a
                                        className="nav-link text-light rounded"
                                        style={{ backgroundColor: "#F93154" }}
                                        id="deuda-tab"
                                        data-bs-toggle="tab" // Aquí el cambio
                                        href="#deuda"
                                        role="tab"
                                        aria-controls="deuda"
                                        aria-selected="true"
                                    >
                                        <i className="fas fa-money-check fa-fw me-2" />
                                        Deudas
                                    </a>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <a
                                        className="nav-link text-dark rounded"
                                        style={{ backgroundColor: "#25d366" }}
                                        id="historico-tab"
                                        data-bs-toggle="tab" // Aquí el cambio
                                        href="#historico"
                                        role="tab"
                                        aria-controls="historico"
                                        aria-selected="false"
                                    >
                                        <i className="fas fa-book-open fa-fw me-2" />
                                        Historico de Pagos
                                    </a>
                                </li>
                                {/*<button
                                    className="btn btn-sm btn-info rounded-pill col-md-2 ml-auto my-2"
                                // onClick={imprimirRelacionPago("Planillacontricomercio")}
                                >
                                    <i className="fas fa-print"> Pagos Web</i>{" "}
                                </button>*/}
                            </ul>
                            <div className="tab-content" id="ex-with-icons-content">
                            <div className="tab-pane fade show active" id="deuda" role="tabpanel" aria-labelledby="deuda-tab">
                                    <div className="row col-md-12">

                                        <div className="col-md-9 row px-0" style={{ margin: "auto" }}>
                                            <button 
                                                onClick={imprimirDeuda} 
                                                style={{ height: '30px', width: '30px' }} 
                                                className="btn btn-sm btn-primary ml-auto rounded-circle mb-2"><i 
                                                className="fas fa-print"></i> </button>

                                            <TblContainer>
                                                <TblHead />

                                                <tbody>
                                                    {deuda && recordsAfterPagingAndSorting().map((row, index) => {
                                                        return (
                                                            <tr key={index} 
                                                                style={{ 
                                                                    padding: "0", 
                                                                    cursor: 'pointer', 
                                                                    background: itemSelect === index ? "lightskyblue" : "white" 
                                                                }} 
                                                                onClick={seleccionarFila(index, row)}>
                                                                <td
                                                                    style={{
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    <b>{row.anio}</b>
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        textAlign: "left",
                                                                    }}
                                                                >
                                                                    {row.mes.toUpperCase()}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        textAlign: "right",
                                                                    }}
                                                                >
                                                                    {formatMoneda(
                                                                        row.monto
                                                                            .toString()
                                                                            .replace(",", "")
                                                                            .replace(".", ","),
                                                                        ",",
                                                                        ".",
                                                                        2
                                                                    )}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        textAlign: "right",
                                                                    }}
                                                                >
                                                                    {formatMoneda(
                                                                        row.intereses
                                                                            .toString()
                                                                            .replace(",", "")
                                                                            .replace(".", ","),
                                                                        ",",
                                                                        ".",
                                                                        2
                                                                    )}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        textAlign: "right",
                                                                    }}
                                                                >
                                                                    {formatMoneda(
                                                                        row.recargo
                                                                            .toString()
                                                                            .replace(",", "")
                                                                            .replace(".", ","),
                                                                        ",",
                                                                        ".",
                                                                        2
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </TblContainer>
                                            <TblPagination />
                                        </div>
                                        <div className='col-md-3 row'>

                                            <div class="input-group input-group-sm mb-0 col-md-12">
                                                <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Deuda:</span>
                                                <input type="text" value={impuesto ? formatMoneda(impuesto.toString().replace(",", "").replace(".", ","), ",", ".", 2) : "0,00"} disabled class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>

                                            <div class="input-group input-group-sm mb-0 col-md-12">
                                                <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Intereses de Mora:</span>
                                                <input type="text" value={interes ? formatMoneda(interes.toString().replace(",", "").replace(".", ","), ",", ".", 2) : "0,00"} disabled class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>

                                            <div class="input-group input-group-sm mb-0 col-md-12">
                                                <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Recargo por Mora:</span>
                                                <input type="text" value={recargo ? formatMoneda(recargo.toString().replace(",", "").replace(".", ","), ",", ".", 2) : "0,00"} disabled class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>

                                            {/*<div class="input-group input-group-sm mb-0 col-md-12">
                                                <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Multa:</span>
                                                <input type="text" value={multa ? formatMoneda(multa.toString().replace(",", "").replace(".", ","), ",", ".", 2) : "0,00"} disabled class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>*/}

                                            <div class="input-group input-group-sm mb-0 col-md-12">
                                                <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Total de la Deuda:</span>
                                                <input type="text" value={totDeuda ? formatMoneda(totDeuda.toString().replace(",", "").replace(".", ","), ",", ".", 2) : "0,00"} disabled class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="historico" role="tabpanel" aria-labelledby="historico-tab">
                                {props.tipo === "comercio" ?
                                        <TablaPagosComercio tabpago={historico} idcomercio={contribuyente.idcontribuyente} />
                                        : props.tipo === "inmueble" ?
                                            <TablaHistoricosInmuebles tabHis={historico} idinmueble={contribuyente.idcontribuyente} />
                                            : props.tipo === "vehiculo" ?
                                                <TablaPagosVehiculos tabpago={historico} idvehi={contribuyente.idcontribuyente} />
                                                : props.tipo === "rentas" ?
                                                    <TablaHistoricosEjidos tabHis={historico} idrentas={contribuyente.idcontribuyente} />
                                                    : props.tipo === "apuestas" ?
                                                        <TablaHistoricosApuestas tabreten={historico} />
                                                        : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="row col-md-12">
                    <button
                        type="button"
                        style={{ maxWidth: 150, marginLeft: 3, marginRight: 3 }}
                        onClick={() => gestionar(1)}
                        className="col-md-3 fw-bold btn btn-primary btn-sm rounded-pill"
                    //  disabled={props.permiso.substring(0, 1) === "0" ? true : false}
                    >
                        <i className="fas fa-plus"></i> Crear
                    </button>
                    <button
                        type="button"
                        style={{ maxWidth: 150, marginLeft: 3, marginRight: 3 }}
                        onClick={() => gestionar(2)}
                        className="col-md-3 fw-bold btn btn-info btn-sm rounded-pill"
                    //   disabled={props.permiso.substring(1, 2) === "0" ? true : false}
                    >
                        <i className="fas fa-edit"></i> Ajustar
                    </button>
                    <button
                        type="button"
                        style={{ maxWidth: 150, marginLeft: 3, marginRight: 3 }}
                        onClick={() => gestionar(3)}
                        className="col-md-3 fw-bold btn btn-warning btn-sm rounded-pill"
                    //   disabled={props.permiso.substring(2, 3) === "0" ? true : false}
                    >
                        <i className="fas fa-sync"></i> Actualizar
                    </button>
                </div>
            </Modal.Footer>
            <Dimmer active={activate} />
            <Mensaje
                mensaje={mensaje}
                onHide={() => {
                    setMensaje({
                        mostrar: false,
                        titulo: "",
                        texto: "",
                        icono: "",
                    });
                }}
            />
            <ModalAgregarDeudaComercio
                show={show}
                operacion={operacion}
                onHide={() => {
                    setShow(false),
                    setOperacion(0)
                }}
                onHideAcepta={() => {
                    setShow(false),
                    setOperacion(0),
                    SelectDeuda()
                }}
                deuda={deudaSel}
                tipo={props.tipo}
                fechaSistema={fechaSistema}
                factorcambio={props.factorcambio}
                contribuyente={props.contribuyente}
                config={config}
            />

            <ModalAgregarDeudaInmueble
                show={show2}
                operacion={operacion}
                onHide={() => {
                    setShow2(false),
                    setOperacion(0)
                }}
                onHideAcepta={() => {
                    setShow2(false),
                    setOperacion(0),
                    SelectDeuda()
                }}
                deuda={deudaSel}
                tipo={props.tipo}
                fechaSistema={fechaSistema}
                factorcambio={props.factorcambio}
                contribuyente={props.contribuyente}
                config={config}
            />
        </Modal>
    );
};
